import DashboardIcon from "@rsuite/icons/Dashboard";
import TagIcon from "@rsuite/icons/Tag";
import SettingIcon from "@rsuite/icons/Setting";
import GearIcon from "@rsuite/icons/Gear";

import ExitIcon from "@rsuite/icons/Exit";
import CalendarIcon from "@rsuite/icons/Calendar";
import VideoIcon from "@rsuite/icons/Video";

export const itemProduct = {
  standard: [
    // {
    //   id: 1,
    //   type: "button",
    //   title: "dashboard",
    //   value: "dashboard",
    //   icon: <DashboardIcon />,
    // },
    {
      id: 2,
      type: "button",
      title: "product",
      value: "",
      icon: <SettingIcon />,
    },
    {
      id: 3,
      type: "button",
      title: "ho_act_Opt_Tarif",
      value: "availability",
      icon: <CalendarIcon />,
    },
    {
      id: 4,
      type: "button",
      title: "promotions",
      value: "promotions",
      icon: <TagIcon />,
    },
    {
      id: 5,
      type: "button",
      title: "informations",
      value: "informations",
      icon: <GearIcon />,
    },
    {
      id: 8,
      type: "button",
      title: "settings",
      value: "settings",
      icon: <GearIcon />,
    },
    {
      id: 9,
      type: "button",
      title: "quit",
      value: "quit",
      icon: <ExitIcon />,
    },
  ],
  transfer: [
    // {
    //   id: 1,
    //   type: "button",
    //   title: "dashboard",
    //   value: "dashboard",
    //   icon: <DashboardIcon />,
    // },
    {
      id: 2,
      type: "button",
      title: "product",
      value: "",
      icon: <SettingIcon />,
    },
    {
      id: 3,
      type: "button",
      title: "ho_act_Opt_Tarif",
      value: "availability",
      icon: <CalendarIcon />,
    },
    {
      id: 4,
      type: "button",
      title: "promotions",
      value: "promotions",
      icon: <TagIcon />,
    },
    {
      id: 5,
      type: "button",
      title: "informations",
      value: "informations",
      icon: <GearIcon />,
    },
    {
      id: 8,
      type: "button",
      title: "settings",
      value: "settings",
      icon: <GearIcon />,
    },
    {
      id: 9,
      type: "button",
      title: "quit",
      value: "quit",
      icon: <ExitIcon />,
    },
  ],

  hotel: [
    // {
    //   id: 1,
    //   type: "button",
    //   title: "dashboard",
    //   value: "dashboard",
    //   icon: <DashboardIcon />,
    // },
    {
      id: 2,
      type: "button",
      title: "product",
      value: "",
      icon: <SettingIcon />,
    sectionName:"product_details"
    },
    {
      id: 3,
      type: "accordion",
      title: "rooms_and_rates",
      value: "availability",
      icon: <CalendarIcon />,
      buttons: [
        { id: 31, title: "ho_act_type", value: "room-types-and-price-levels",
    sectionName:"ho_act_type" },
        {
          id: 32,
          title: "ho_act_Opt_Tarif",
          value: "availability",
    sectionName:"ho_act_Opt_Tarif"
        },
        {
          id: 33,
          title: "avl_man_segment",
          value: "pricing-options-and-Availability",
    sectionName:"ho_act_tarif_rest"
        },
        // { id: 4, title: "rates_and_rest", value: "restrictions" },
        // { id: 5, title: "ho_act_cancellation", value: "cancellation-policy" },
        { id: 36, title: "ho_act_frais_ind", value: "accupancy-and-fees",
    sectionName:"ho_act_frais_ind" },
        // { id: 7, title: "availability_updates_by_block", value: "availability_updates_by_block" },
      ],
    },
    {
      id: 4,
      type: "button",
      title: "promotions",
      value: "promotions",
      icon: <TagIcon />,
    sectionName:"promotions"
    },
    {
      id: 5,
      type: "button",
      title: "informations",
      value: "informations",
      icon: <GearIcon />,
    sectionName:"Administration"
    },
    {
      id: 6,
      type: "button",
      title: "Photos",
      value: "album",
      icon: <VideoIcon />,
    sectionName:"add_photos"
    },
    // {
    //   id: 8,
    //   type: "button",
    //   title: "settings",
    //   value: "settings",
    //   icon: <GearIcon />,
    // },
    {
      id: 9,
      type: "button",
      title: "quit",
      value: "quit",
      icon: <ExitIcon />,
    sectionName:"quit"
    },
  ],
  flight: [
    // {
    //   id: 1,
    //   type: "button",
    //   title: "dashboard",
    //   value: "dashboard",
    //   icon: <DashboardIcon />,
    // },
    {
      id: 2,
      type: "button",
      title: "product",
      value: "",
      icon: <SettingIcon />,
    },
    {
      id: 3,
      type: "button",
      title: "ho_act_Opt_Tarif",
      value: "availability",
      icon: <CalendarIcon />,
    },
    {
      id: 4,
      type: "button",
      title: "promotions",
      value: "promotions",
      icon: <TagIcon />,
    },

    {
      id: 8,
      type: "button",
      title: "settings",
      value: "settings",
      icon: <GearIcon />,
    },
    {
      id: 9,
      type: "button",
      title: "quit",
      value: "quit",
      icon: <ExitIcon />,
    },
  ],
};
